/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Catalog_Endpoints_SingleInputs */

const en_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open one for its request, response and free sample.`)
};

const zh_hans1_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开一个接口，查看它的请求、响应和免费示例。`)
};

const pt_br2_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra um para ver a requisição, a resposta e uma amostra grátis.`)
};

const es_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre uno para ver su solicitud, respuesta y muestra gratis.`)
};

const fr_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez-en un pour voir sa requête, sa réponse et son exemple gratuit.`)
};

const de_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne einen für Anfrage, Antwort und kostenloses Beispiel.`)
};

const ru_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте эндпоинт, чтобы увидеть запрос, ответ и бесплатный пример.`)
};

const it_app_catalog_endpoints_single = /** @type {(inputs: App_Catalog_Endpoints_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprine uno per vedere richiesta, risposta e campione gratuito.`)
};

/**
* | output |
* | --- |
* | "Open one for its request, response and free sample." |
*
* @param {App_Catalog_Endpoints_SingleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_catalog_endpoints_single = /** @type {((inputs?: App_Catalog_Endpoints_SingleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Catalog_Endpoints_SingleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_catalog_endpoints_single(inputs)
	if (locale === "pt-BR") return pt_br2_app_catalog_endpoints_single(inputs)
	if (locale === "es") return es_app_catalog_endpoints_single(inputs)
	if (locale === "fr") return fr_app_catalog_endpoints_single(inputs)
	if (locale === "de") return de_app_catalog_endpoints_single(inputs)
	if (locale === "ru") return ru_app_catalog_endpoints_single(inputs)
	if (locale === "it") return it_app_catalog_endpoints_single(inputs)
	return en_app_catalog_endpoints_single(inputs)
});